// @ts-nocheck

import palette from '../palette';

export const NumericKeyboard = {
  default: {
    color: palette.neutralgrey200,
    backgroundColor: palette.bluegrey800,
  },
  special: {
    color: palette.neutralgrey200,
    backgroundColor: palette.bluegrey750,
  },
  active: {
    color: palette.white,
    backgroundColor: palette.bluegrey850,
  },
  disabled: {
    color: palette.silver340,
    backgroundColor: palette.neutralgrey800,
  },
};
